import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Styles from './LayerStatisticsBarGroup.module.less';
import StyleConstants from '../../../StyleConstants';
import type { LayerStatisticsItem } from '../sources/LayerStatisticsSourceTypes';

const positionBreakpoint = 38;

type LayerStatisticsBarGroupProps = {
  barHeight: number;
  entry: LayerStatisticsItem;
  width: number;
};

const LayerStatisticsBarGroup = ({ barHeight, entry, width }: LayerStatisticsBarGroupProps) => {
  const barColour = StyleConstants.palette.primary.main;

  const widthScale = (d: number) => {
    if (width === null || width === undefined) {
      return d * 5;
    }
    return d * (width / 100);
  };

  const scaledWidth = widthScale(entry.percentage);
  return (
    <Box
      className={Styles.group}
      sx={{
        height: barHeight,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        mt: 1,
      }}
    >
      <Box className={Styles.name}>{entry.item}</Box>
      {scaledWidth >= positionBreakpoint && (
        <Box
          className={Styles.bar}
          sx={{
            display: 'flex',
            width: scaledWidth,
            bgcolor: barColour,
            alignItems: 'center',
            justifyContent: 'end',
          }}
        >
          <p className={Styles.inside}>{entry.percentage}%</p>
        </Box>
      )}
      {scaledWidth < positionBreakpoint && (
        <Box
          className={Styles.bar}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Box
            className={Styles.bar}
            sx={{
              width: scaledWidth,
              bgcolor: barColour,
            }}
          />
          <p className={Styles.outside}>{entry.percentage}%</p>
        </Box>
      )}
    </Box>
  );
};

export default memo(LayerStatisticsBarGroup);
